module.exports = __webpack_public_path__ + "img/product.32f1495a.svg";